module.exports = __webpack_public_path__ + "img/5.6e384682.png";